<template>
  <div class="">
    <form data-vv-scope="onboard-form" @submit="submit">
      <div class="mb-3">
        <div class="row">
          <div class="col">
            <div class="form-group">
              <label>Doctor First Name</label>
              <input
                v-model="doctorFirst"
                type="text"
                class="form-control form-control-lg"
                @change="onNameChange"
                name="doctor_firstname"
                data-vv-as="doctor's first name"
                v-validate
                required
              />
              <span class="invalid-feedback d-block">{{ errors.first('doctor_firstname', 'onboard-form') }}</span>
            </div>
          </div>
          <div class="col">
            <div class="form-group">
              <label>Doctor Last Name</label>
              <input
                v-model="doctorLast"
                type="text"
                class="form-control form-control-lg"
                @change="onNameChange"
                name="doctor_lastname"
                data-vv-as="doctor's last name"
                v-validate
                required
              />
              <span class="invalid-feedback d-block">{{ errors.first('doctor_lastname', 'onboard-form') }}</span>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <div class="form-group">
              <label>Office Phone</label>
              <input
                type="text"
                class="form-control form-control-lg"
                required
                v-validate="{ required: true, regex: /\(\d{3}\)\s\d{3}-\d{4}/ }"
                name="office_phone"
                data-vv-as="office phone"
                :value="officePhone"
                @input="phoneChange"
              />
              <span class="invalid-feedback d-block">{{ errors.first('office_phone', 'onboard-form') }}</span>
            </div>
          </div>
          <div class="col-12 d-none">
            <div class="form-group">
              <label>Office Name</label>
              <input
                v-model="officeName"
                type="text"
                class="form-control form-control-lg"
                @change="isOfficeNameEdited = !!$event.target.value"
                name="office_name"
                data-vv-as="office name"
                v-validate
                required
              />
              <span class="invalid-feedback d-block">{{ errors.first('office_name', 'onboard-form') }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col text-right">
          <button class="btn-primary btn btn-xl">Send a referral</button>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import AddDoctor from '../../components/AddDoctor.vue'
export default {
  components: { AddDoctor },
  data() {
    return {
      doctorFirst: '',
      doctorLast: '',
      officeName: '',
      officePhone: '',
      timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      isOfficeNameEdited: false,
    }
  },
  computed: {
    doctorFull() {
      return this.doctorFirst + ' ' + this.doctorLast
    },
  },
  methods: {
    onNameChange() {
      if (this.isOfficeNameEdited) return
      this.officeName = this.doctorFull
    },
    async validate() {
      return this.$validator.validate('onboard-form.*')
    },
    async submit(e) {
      e.preventDefault()
      if (await this.validate()) {
        this.$store.dispatch('auth/registerPublicUser', {
          firstName: this.doctorFirst,
          lastName: this.doctorLast,
          officeName: this.officeName,
          officePhone: this.officePhone,
          timezone: this.timezone,
          toPracticeId: this.$route.params.to,
        })
      }
    },
    phoneChange(e) {
      this.officePhone = this.$options.filters.phone(e.target.value)
    },
  },
}
</script>

<style>
</style>